import React from 'react';
import Support from '../../../../assets/Support.png';
import CodeLogo from '../../../../assets/features/code.svg';
import EmailLogo from '../../../../assets/features/email.svg';

import './SupportSection.css';

const SupportSection = () => {
    return (
        <div className="container support__container">
            <h2 className="support__mainHeading">
                Customer Support Is Our Main Priority
            </h2>
            <div className="row support__subSection align-items-center">
                <div className="col-md-6 d-flex flex-column"> 
                    <h3>
                        Do you need help? Our support team ready to help you
                    </h3>
                    <p>
                        Get your tests delivered at let home collect sample from the victory of the managments that supplies best design system guidelines ever.
                    </p>
                    <div className="row  support__subContentBox" id="email__content">
                        <div className="col-sm-2">
                            <img src={EmailLogo} alt="email-logo" className="w-100"/>
                        </div>
                        <div className="col-sm-10 d-flex flex-column">
                            <h5>
                                Email client support
                            </h5>
                            <p>
                                Ultimate access to all credit popular exercises and assessments materials
                            </p>
                        </div>      
                        <div className="col-sm-2">
                            <img src={CodeLogo} alt="code-logo" className="w-100"/>
                        </div>
                        <div className="col-sm-10 d-flex flex-column">
                            <h5>
                                Email client support
                            </h5>
                            <p>
                                Ultimate access to all credit popular exercises and assessments materials
                            </p>
                        </div>                       
                    </div>
                </div>
                <div className="col-md-6">
                    <img src={Support} alt="support" className="w-100"/>
                </div>
            </div>
        </div>
    )
}

export default SupportSection
